import $ from 'jquery';
import jQuery from 'jquery';

export default function availModal(item) {
    // Get the modal
    var modal = $('#share-modal');
    // Get the button that opens the modal
    var btn = $('#share-to-media');
    // Get the <span> element that closes the modal
    var span = $('.close')[0];
    // Open and close the modal
    // btn.onclick = function() {
        modal.show();
    // }
    span.onclick = function() {
        modal.hide();
    }
    $(window).on( "click", function(event) {
        if (event.target == modal) {
            modal.hide();
        }
    });
}
